import { render } from "./examination-detail.vue?vue&type=template&id=09eb75ae&scoped=true&ts=true"
import script from "./examination-detail.vue?vue&type=script&lang=ts"
export * from "./examination-detail.vue?vue&type=script&lang=ts"

import "./examination-detail.vue?vue&type=style&index=0&id=09eb75ae&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09eb75ae"]])

export default __exports__